import {Container} from "./Container"
import {StudentActiveContainer} from "../../components/courseView/StudentActiveContainer"

export const MyLearningCenterStyles = {
    Container: Container,
    StudentActiveContainer: StudentActiveContainer
}